import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getCdrBillProcess } from '../../../../actions';

const BillingCdrButton = ({ dispatchGetCdrBillProcess, ticketId, loading }) => {
  if (!ticketId) return null;

  const handleDownload = (e) => {
    e.stopPropagation();
    if (!ticketId || loading) return;
    dispatchGetCdrBillProcess(ticketId);
  };

  return (
    <div
      tabIndex={0}
      role="button"
      onClick={handleDownload}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && !loading) {
          e.preventDefault();
          handleDownload(e);
        }
      }}
      title={loading ? 'Cargando...' : 'Descargar CDR de la Facturación'}
      style={{
        cursor: loading ? 'not-allowed' : 'pointer',
        width: '48px',
        height: '48px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        border: '1px solid #007bff',
        backgroundColor: loading ? '#f0f0f0' : 'white',
        color: '#007bff',
        fontSize: '11px',
        transition: 'all 0.2s ease-in-out',
        opacity: loading ? 0.6 : 1,
        pointerEvents: loading ? 'none' : 'auto',
      }}
    >
      {loading ? (
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: '20px', height: '20px' }}
        >
          <span className="visually-hidden">...</span>
        </div>
      ) : (
        <>
          <i
            className="fa fa-file-code-o"
            style={{
              fontSize: '16px',
              marginBottom: '3px',
              color: '#007bff',
            }}
          />
          <span style={{ color: '#007bff', fontWeight: 'bold' }}>CDR</span>
        </>
      )}
    </div>
  );
};

BillingCdrButton.propTypes = {
  dispatchGetCdrBillProcess: PropTypes.func.isRequired,
  ticketId: PropTypes.string,
  loading: PropTypes.bool,
};

BillingCdrButton.defaultProps = {
  ticketId: null,
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.Billing.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetCdrBillProcess: getCdrBillProcess,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingCdrButton);
